"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var alarm_svg_1 = __importDefault(require("../../../assets/icons/data_e_hora/alarm.svg"));
var calendar_month_svg_1 = __importDefault(require("../../../assets/icons/data_e_hora/calendar_month.svg"));
var schedule_svg_1 = __importDefault(require("../../../assets/icons/data_e_hora/schedule.svg"));
var timer_svg_1 = __importDefault(require("../../../assets/icons/data_e_hora/timer.svg"));
var DataEHora = {
    "alarm": alarm_svg_1.default,
    "calendar": calendar_month_svg_1.default,
    "schedule": schedule_svg_1.default,
    "Timer": timer_svg_1.default,
};
exports.default = DataEHora;
